export default __webpack_public_path__ + "static/media/back1.5d5e672a.jpg";